import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { EnrollmentExtendedService } from 'src/app/core/services/onboarding/enrollment-extended.service';
import { reloadApp } from 'src/app/core/ui-helpers/functions/redirect/reload-app';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-nowaccount-activate-dashboard',
  templateUrl: './nowaccount-activate-dashboard.component.html',
  styleUrls: ['./nowaccount-activate-dashboard.component.scss'],
})
export class NowaccountActivateDashboardComponent {
  constructor(
    private router: Router,
    private ess: EnrollmentExtendedService,
  ) {}

  async clickEvent(): Promise<boolean> {
    // Activate client by calling API
    const data = await this.ess.activateClient();
    // If the response is true navigate to the old dashboard screen
    if (data) {
      return reloadApp(environment);
    }
    return false;
  }
}
